import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-links">
          <Link to="/regulamin" className="footer-link">Regulamin</Link>
          <Link to="/polityka-prywatnosci" className="footer-link">Polityka prywatności</Link>
        </div>
        <div className="footer-copyright">
          &copy; {new Date().getFullYear()} Sparingownia
        </div>
      </div>
    </footer>
  );
}

export default Footer;
